import { keyValueStore } from '@neptune/content-addressable-store-domain';

import { isSupportedCompareDataDTO } from './compare-data-dto';
import { type CompareContent, CompareDataModelConverter } from './compare-data-model-converter';
import { filterArchivedEntities } from './filter-archived-entities';

export type CompareContentWithRequestId = CompareContent & { requestId: number };

export async function persistCompareStateToStore({
  requestId,
  ...content
}: CompareContentWithRequestId) {
  return keyValueStore.persistObjectAndWait(CompareDataModelConverter.fromDomainToApi(content));
}

export async function loadCompareStateFromStore(key: string): Promise<CompareContent | null> {
  const raw = await keyValueStore.loadObject(key, isSupportedCompareDataDTO);

  if (!raw) {
    return null;
  }

  const content = CompareDataModelConverter.fromApiToDomain(raw);
  const filteredCompare = await filterArchivedEntities(content.projectIdentifier, content.compare);

  return {
    ...content,
    compare: filteredCompare,
  };
}
